import { Flex, Image } from "@chakra-ui/react";
import { MdAttachMoney } from "react-icons/md";
import colors from "core/resources/theme/colors";
import DashboardCard from "components/Cards/DashboardCard";
import { useSaldo } from "features/dashboards/hooks/useSaldo";
import { formatMoney } from "infra/helpers/number";
import useGetContasBancarias from "features/contas_bancarias/hooks/useGetContasBancarias";
import { TenantContaResponse } from "features/contas_bancarias/typings";
import { MdAccountBalance } from "react-icons/md";
import { BiChevronDown } from "react-icons/bi";

import { Dropdown, Menu } from "antd";
import { useState } from "react";

function CardSaldo() {
  const { isFetching: isFetchingContas, data: contas } = useGetContasBancarias({
    incluirInativas: true,
  });

  const [selected, setSelected] = useState<TenantContaResponse>();
  const { data, isFetching } = useSaldo({
    contaBancariaId: selected?.id ?? undefined,
  });

  return (
    <DashboardCard
      isLoading={isFetching}
      positive={true}
      bg={colors.lightGray}
      label="Saldo"
      valuePercent={null}
      value={formatMoney(data?.total ?? 0)}
      icon={<MdAttachMoney fontSize="32px" color={colors.darkGray} />}
      right={
        <Flex>
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item onClick={() => setSelected(undefined)}>
                  Todas
                </Menu.Item>
                {contas?.items.map((c, index) => (
                  <Menu.Item onClick={() => setSelected(c)} key={index}>
                    <Flex gap="8px" alignItems={"center"}>
                      {c.imagemUrl ? (
                        <Image
                          w="28px"
                          h="28px"
                          rounded="4px"
                          src={c.imagemUrl}
                        />
                      ) : (
                        <Flex
                          w="28px"
                          h="28px"
                          rounded="4px"
                          bg="gray.100"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <MdAccountBalance color={colors.black700} />
                        </Flex>
                      )}
                      {c.nome}
                    </Flex>
                  </Menu.Item>
                ))}
              </Menu>
            }
            trigger={["click"]}
          >
            <Flex
              _hover={{ opacity: 0.8 }}
              cursor="pointer"
              color="#66696B"
              h="30px"
              alignItems={"center"}
            >
              {isFetchingContas
                ? "Carregando..."
                : selected
                ? selected.nome
                : "Todas"}{" "}
              <BiChevronDown />
            </Flex>
          </Dropdown>
        </Flex>
      }
    />
  );
}

export default CardSaldo;
